import { useState } from "react";
import { AssessmentStatus, Leads } from "../../../../model/leads/leads";
import styles from "../LeadsPage.module.scss";
import { calculateTimeDifference, formatDate, formatEnumString } from "../../../../utils";
import { ClockLoader } from "../../../../assets/icons";
import ActiveLeadSideDialogue from "./lead-side-dalogue/LeadSideDialog";
import LeadsTable, { Column } from "./LeadsTable";

interface ActiveLeadsProps {
	data: Leads[];
}
const ActiveLeads = ({ data }: ActiveLeadsProps) => {
	const [openSideDialogue, setOpenSideDialogue] = useState(false);
	const [selectedLead, setSelectedLead] = useState<Leads>();

	const handleDetailView = (item: Leads) => {
		setOpenSideDialogue(true);
		setSelectedLead(item);
	};

	const getStatusClass = (status: AssessmentStatus) => {
		switch(status) {
			case AssessmentStatus.CheckingDigitalLoadAssessment:
				return {styleName: styles.status_badge_pending, text: "Pending"};
			case AssessmentStatus.ScheduledPhysicalLoadAssessment:
				return { styleName: styles.status_badge_scheduled, text: "Scheduled"}
				case AssessmentStatus.RescheduledPhysicalLoadAssessment:
				return { styleName: styles.status_badge_rescheduled, text: "Re Scheduled"}
			case AssessmentStatus.CarringOutPhysicalLoadAssessment:
				return { styleName: styles.status_badge_progress, text: "In Progress"}
			case AssessmentStatus.OverduePhysicalLoadAssessment:
				return { styleName: styles.status_badge_overdue, text: "Overdue"}
			case AssessmentStatus.SendingProductsThatFit:
				return { styleName: styles.status_badge_completed, text: "Done" }
			default:
				return { styleName: "", text: "-" };
		}
	};

	const columns: Column<Leads>[] = [
		{
			header: "CUSTOMER NAME",
			accessor: "user",
			render: item => `${item.user?.firstName || ''} ${item.user?.lastName || ''}`,
		},
		{
			header: "LEAD STATUS",
			accessor: "status",
			render: item => formatEnumString(AssessmentStatus[item.status])
		},
		{
			header: "ASSIGNED PROVIDER",
			accessor: "company",
			render: item => item?.company?.name,
		},
		{
			header: "LOAD ASSESSMENT STATUS",
			accessor: "status",
			render: item => {
				const { styleName, text } = getStatusClass(item.status)
				return <span className={`${styles.status_badge} ${styleName}`}>
					{item.status === AssessmentStatus.CarringOutPhysicalLoadAssessment  && <ClockLoader />} {text}
				</span>
			},
		},
		{
			header: "DATE CREATED",
			accessor: "createdAt",
			render: item => formatDate(item.createdAt),
		},
		{
			header: "TIMELINE",
			accessor: "assessmentDetails",
			render: item => <span className={styles.subSubText}>{calculateTimeDifference(item.createdAt)}</span>,
		},
		{
			header: "VIEW DETAILS",
			accessor: "id",
			render: item => (
				<button className="actionButton" onClick={() => handleDetailView(item)}>
					VIEW DETAILS
				</button>
			),
		},
	];

	return (
		<>
			{openSideDialogue && selectedLead && <ActiveLeadSideDialogue data={selectedLead} onClose={() => setOpenSideDialogue(false)} />}
            <LeadsTable<Leads>
              columns={columns}
              data={data}
              tableContainerClassName={styles.tableContainer}
            />
		</>
	);
};
export default ActiveLeads;
